import { useState, useEffect } from 'react';
import { map } from 'lodash';

import Generales from '../../../documents/Recursos/Formatos/generales.json';

import { Col, Container, Row, Spinner } from 'react-bootstrap';
import ReturnBar from '../../../components/ReturnBar/ReturnBar';
import CardItem from '../../../components/Cards/CardItem/CardItem';
import PdfModal from '../../../components/Modal/PdfModal/PdfModal';
import './Formatos.scss';


export default function Formatos() {

    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [contentModal, setContentModal] = useState(null);
    const [formatos, setFormatos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setFormatos(Generales);
        setIsLoading(false);
    }, []);

    return (
        <div className="formatos">
            <ReturnBar />
            {
                isLoading ? (
                    <div className="tripticos__loading">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <Container>
                        <h2 className="formatos__titulo">Formatos intelimundo</h2>
                        <Row>
                            {
                                map(formatos, items => (
                                    <Col lg={12} md={12} className="gy-5" key={items} >
                                        <CardItem
                                            element={items}
                                            setShowModal={setShowModal}
                                            setTitleModal={setTitleModal}
                                            setContentModal={setContentModal}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                )
            }

            <PdfModal show={showModal} setShow={setShowModal} title={titleModal}>
                {contentModal}
            </PdfModal>
        </div>
    );
}
